import { render, staticRenderFns } from "./ExitAlert.vue?vue&type=template&id=5f035d18&"
import script from "./ExitAlert.vue?vue&type=script&lang=js&"
export * from "./ExitAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports